<template>
  <div>
    <el-dialog
      ref="shipmentDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h800_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('shipmentDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogShipmentForm"
          :model="dialogShipmentForm"
          :rules="dialogShipmentFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="订单类型">
                    <el-radio-group v-model="dialogViewForm.type">
                      <el-radio
                        :label="1"
                        disabled
                      >
                        委托制作
                      </el-radio>
                      <el-radio
                        :label="2"
                        disabled
                      >
                        购买
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="供应商">
                    <el-input
                      v-model="dialogViewForm.supplierName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单日期">
                    <el-date-picker
                      v-model="dialogViewForm.orderDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单总金额">
                    <el-input
                      v-model="dialogViewForm.orderAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预计制作完成日期">
                    <el-date-picker
                      v-model="dialogViewForm.estimatedCompleteDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="实际制作完成日期">
                    <el-date-picker
                      v-model="dialogShipmentForm.completeDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="经办人">
                    <el-input
                      v-model="dialogViewForm.manager"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="物料制作费用">
                    <el-input
                      v-model="dialogViewForm.makeAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="其他费用">
                    <el-input
                      v-model="dialogViewForm.otherAmount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="其他费用说明">
                    <el-input
                      v-model="dialogViewForm.otherReason"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              物料发货信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="8">
                  <el-form-item label="批量设置制作进度">
                    <el-radio-group
                      v-model="batchSetComplete"
                      @change="batchCompleteChangeFun"
                    >
                      <el-radio :label="1">
                        制作完成
                      </el-radio>
                      <el-radio :label="2">
                        未完成
                      </el-radio>
                      <el-radio :label="3">
                        还原
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="批量设置发货进度">
                    <el-radio-group
                      v-model="batchSetShipment"
                      @change="batchShipmentChangeFun"
                    >
                      <el-radio :label="1">
                        已发货
                      </el-radio>
                      <el-radio :label="2">
                        未发货
                      </el-radio>
                      <el-radio :label="3">
                        还原
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="批量设置运输方式">
                    <el-select
                      v-model="batchSetTransferMethod"
                      filterable
                      clearable
                      placeholder="请选择运输方式"
                      style="width:100%"
                      @change="batchTransferMethodChangeFun"
                    >
                      <el-option
                        v-for="item in transferMethodOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-table
                    :data="dialogShipmentForm.orderShipmentList"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      label="省区"
                      prop="arrivalProvinceName"
                      align="center"
                      width="75"
                    />
                    <el-table-column
                      label="市场"
                      prop="arrivalCityName"
                      align="center"
                      show-overflow-tooltip
                      width="100"
                    />
                    <el-table-column
                      label="物料名称"
                      prop="materialsName"
                      show-overflow-tooltip
                      width="180"
                    />
                    <el-table-column
                      label="数量"
                      prop="makeNumber"
                      align="center"
                      width="90"
                    />
                    <el-table-column
                      label="制作进度"
                      align="center"
                      width="110"
                    >
                      <template slot-scope="scope">
                        <el-checkbox
                          v-model="scope.row.productionComplete"
                          :true-label="1"
                          :false-label="0"
                          size="small"
                          :disabled="Number(scope.row.arrivalDepotNumber) > 0"
                        >
                          制作完成
                        </el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="发货进度"
                      align="center"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-checkbox
                          v-model="scope.row.isShipment"
                          :true-label="1"
                          :false-label="0"
                          size="small"
                          :disabled="Number(scope.row.arrivalDepotNumber) > 0"
                        >
                          已发货
                        </el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="运输方式"
                      align="center"
                      width="150"
                    >
                      <template slot-scope="scope">
                        <el-select
                          v-model="scope.row.transferMethodSelect"
                          filterable
                          clearable
                          placeholder="请选择运输方式"
                          style="width:100%"
                          :disabled="Number(scope.row.arrivalDepotNumber) > 0"
                        >
                          <el-option
                            v-for="item in transferMethodOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="发货信息内容"
                      prop="shipmentContent"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.shipmentContent"
                          size="mini"
                          maxlength="250"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="固定资产"
                      align="center"
                      width="80"
                    >
                      <template slot-scope="scope">
                        <el-checkbox
                          v-model="scope.row.isFixedAsset"
                          :true-label="1"
                          :false-label="0"
                          size="small"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { initCommissionedOrderApi, shipmentCommissionedOrderApi } from '@/api/materialsCommissionedOrder'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    },
    sendArray: {
      type: Array,
      default: null
    },
    supplier: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogViewForm: {},
      dialogShipmentForm: {},
      dialogShipmentFormRules: {
        // provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
      },
      transferMethodOptions: [{ value: 1, label: '自提' }, { value: 2, label: '快递' }, { value: 3, label: '物流' }, { value: 4, label: '其他' }],
      batchSetComplete: 0,
      batchSetShipment: 0,
      batchSetTransferMethod: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false

        this.batchSetComplete = 0
        this.batchSetShipment = 0
        this.batchSetTransferMethod = ''

        this.dialogViewForm = {}
        this.dialogShipmentForm = {}
        this.initData()

        this.$nextTick(() => {
          this.$refs.dialogShipmentForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    initData() {
      initCommissionedOrderApi({ id: this.dataId, operate: 'shipment' }).then(response => {
        const { data } = response
        let orderData = data.materialsCommissionedOrder
        let orderShipmentList = data.orderShipmentList

        this.dialogViewForm = orderData
        orderShipmentList.forEach(item => {
          item.transferMethodSelect = item.transferMethod > 0 ? item.transferMethod : ''
          item.oldProductionComplete = item.productionComplete
          item.oldIsShipment = item.isShipment
        })
        this.dialogShipmentForm = {
          id: orderData.id,
          completeDate: orderData.completeDateValue,
          orderShipmentList: orderShipmentList,
          orderShipmentData: '' // 物料发货清单JSON字符串
        }
        this.loading = false
      })
    },
    // 批量设置制作进度
    batchCompleteChangeFun(val) {
      if (val === 1) { // 完成
        this.dialogShipmentForm.orderShipmentList.forEach(item => {
          if (Number(item.arrivalDepotNumber) === 0) item.productionComplete = 1
        })
      } else if (val === 2) { // 未完成
        this.dialogShipmentForm.orderShipmentList.forEach(item => {
          if (Number(item.arrivalDepotNumber) === 0) item.productionComplete = 0
        })
      } else if (val === 3) { // 还原
        this.dialogShipmentForm.orderShipmentList.forEach(item => {
          if (Number(item.arrivalDepotNumber) === 0) item.productionComplete = item.oldProductionComplete
        })
      }
    },
    // 批量设置发货进度
    batchShipmentChangeFun(val) {
      if (val === 1) { // 已发货
        this.dialogShipmentForm.orderShipmentList.forEach(item => {
          if (Number(item.arrivalDepotNumber) === 0) item.isShipment = 1
        })
      } else if (val === 2) { // 未发货
        this.dialogShipmentForm.orderShipmentList.forEach(item => {
          if (Number(item.arrivalDepotNumber) === 0) item.isShipment = 0
        })
      } else if (val === 3) { // 还原
        this.dialogShipmentForm.orderShipmentList.forEach(item => {
          if (Number(item.arrivalDepotNumber) === 0) item.isShipment = item.oldIsShipment
        })
      }
    },
    // 批量设置运输方式
    batchTransferMethodChangeFun(val) {
      this.dialogShipmentForm.orderShipmentList.forEach(item => {
        if (Number(item.arrivalDepotNumber) === 0) item.transferMethodSelect = val

      })
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogShipmentForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogShipmentForm.validate(valid => {
        if (valid) {
          // 验证明细清单中的制作进度、发货进度、运输方式
          let isBreak = false
          this.dialogShipmentForm.orderShipmentList.forEach(item => {
            if (isBreak) return
            if (Number(item.productionComplete) === 0 && Number(item.isShipment) === 1) {
              this.$message({ message: item.arrivalCityName + '市场 物料[' + item.materialsName + ']未制作完成，不能选择已发货', type: 'warning' })
              isBreak = true
            } else if (Number(item.isShipment) === 0 && item.transferMethodSelect) {
              this.$message({ message: item.arrivalCityName + '市场 物料[' + item.materialsName + ']未发货，不能选择运输方式', type: 'warning' })
              isBreak = true
            } else if (Number(item.isShipment) === 1 && !item.transferMethodSelect) {
              this.$message({ message: item.arrivalCityName + '市场 物料[' + item.materialsName + ']已发货，请选择运输方式', type: 'warning' })
              isBreak = true
            }
            item.transferMethod = item.transferMethodSelect || 0
          })
          if (isBreak) return false

          this.$confirm(
            '是否确定更新物料委托制作单进度', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.operateButtonDisable = true
            this.loading = true
            this.loadingText = '正在处理数据中，请耐心等待'

            this.dialogShipmentForm.orderShipmentData = JSON.stringify(this.dialogShipmentForm.orderShipmentList)

            shipmentCommissionedOrderApi(this.dialogShipmentForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
              this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}
</style>
